/* ASlingSwing custom JS.
   - Variant buttons on collection product blocks: pick a variant, update price + add-to-cart id.
   - No auto-rotating carousel (images are swipeable manually via CSS scroll-snap). */
(function () {
  function initVariantButtons(root) {
    (root || document).querySelectorAll('[data-ass-options]').forEach(function (group) {
      if (group.dataset.assInit) return;
      group.dataset.assInit = '1';
      var block = group.closest('.ass-pb');
      if (!block) return;
      var jsonEl = block.querySelector('[data-ass-variants-json]');
      var variants = [];
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var idInput = block.querySelector('[data-ass-id]');
      var priceEl = block.querySelector('[data-ass-price]');
      var addBtn = block.querySelector('.ass-pb__add');

      function currentSelection() {
        var sel = [];
        group.querySelectorAll('.ass-pb__option').forEach(function (opt, i) {
          var active = opt.querySelector('.ass-pb__variant-btn.is-active');
          sel[i] = active ? active.getAttribute('data-value') : null;
        });
        return sel;
      }
      function update() {
        var sel = currentSelection();
        var match = variants.find(function (v) {
          return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
        });
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceEl && match.price_money) priceEl.textContent = match.price_money;
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
        }
      }
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.ass-pb__variant-btn');
        if (!btn) return;
        var opt = btn.closest('.ass-pb__option');
        opt.querySelectorAll('.ass-pb__variant-btn').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        update();
      });
      update();
    });
  }

  // Manual page: deter image saving (right-click + drag)
  function initManualProtect() {
    if (!document.querySelector('[data-ass-manual]')) return;
    var area = document.querySelector('.page__content');
    if (!area || area.dataset.assProtected) return;
    area.dataset.assProtected = '1';
    area.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    area.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  // Top carousel: dots + autoplay + swipe
  function initTopCarousel(root) {
    (root || document).querySelectorAll('[data-ass-top-carousel]').forEach(function (c) {
      if (c.dataset.assInit) return;
      c.dataset.assInit = '1';
      var track = c.querySelector('[data-ass-tc-track]');
      if (!track) return;
      var slides = track.children;
      if (slides.length < 2) return;
      var dotsWrap = c.querySelector('[data-ass-tc-dots]');
      var idx = 0, paused = false, dots = [];

      function setActive() { dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); }); }
      function go() { track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' }); setActive(); }

      if (dotsWrap) {
        for (var i = 0; i < slides.length; i++) {
          var d = document.createElement('button');
          d.className = 'ass-top-carousel__dot' + (i === 0 ? ' is-active' : '');
          d.type = 'button';
          d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          (function (n) { d.addEventListener('click', function () { idx = n; go(); }); })(i);
          dotsWrap.appendChild(d);
          dots.push(d);
        }
      }
      track.addEventListener('scroll', function () { if (track.clientWidth) { idx = Math.round(track.scrollLeft / track.clientWidth); setActive(); } }, { passive: true });
      ['pointerenter', 'touchstart'].forEach(function (e) { c.addEventListener(e, function () { paused = true; }, { passive: true }); });
      ['pointerleave', 'touchend'].forEach(function (e) { c.addEventListener(e, function () { paused = false; }, { passive: true }); });

      var secs = parseInt(c.getAttribute('data-autoplay') || '0', 10);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (secs > 0 && !reduce) {
        setInterval(function () { if (paused || !c.isConnected) return; idx = (idx + 1) % slides.length; go(); }, secs * 1000);
      }
    });
  }

  // Featured product: move "Learn more" between Add to cart and Buy-with-Shop
  function initFeaturedButtons(root) {
    (root || document).querySelectorAll('.product-single--featured').forEach(function (f) {
      if (f.dataset.assBtns) return;
      var learnMore = f.querySelector('.product-single__box__block--button');
      if (!learnMore) return;
      var tries = 0;
      (function place() {
        var payment = f.querySelector('.shopify-payment-button');
        if (payment && payment.parentNode) {
          f.dataset.assBtns = '1';
          payment.parentNode.insertBefore(learnMore, payment);   // Add to cart | Learn more | Buy with Shop
        } else if (tries++ < 30) {
          setTimeout(place, 250);   // Shop Pay button can render late
        }
      })();
    });
  }

  // Footer: move the social-media icons out of the Contact block and place them
  // directly under the logo (right-hand column).
  function initFooterSocialUnderLogo() {
    var logoNav = document.querySelector('.footer-nav--image');
    var social = document.querySelector('.footer-nav--contact .footer-nav__social-wrapper');
    if (!logoNav || !social || logoNav.dataset.assSocial) return;
    logoNav.dataset.assSocial = '1';
    social.classList.add('ass-footer-social');
    logoNav.appendChild(social);   // under the logo image
  }

  // Header PRODUCTS dropdown: the "main-menu" is missing Model X and the A T-Shirt.
  // Menu items live in Shopify admin, so inject them client-side into every menu list
  // that holds the product links (desktop nav + mobile drawer).
  function initProductsDropdownExtras() {
    function makeItem(href, text) {
      var li = document.createElement('li');
      li.className = 'list-menu__item';
      li.innerHTML = '<a href="' + href + '" class="list-menu__link"><span class="list-menu__text">' + text + '</span></a>';
      return li;
    }
    document.querySelectorAll('a[href="/products/model-s"]').forEach(function (ref) {
      var ul = ref.closest('ul');
      if (!ul || ul.dataset.assExtras) return;
      ul.dataset.assExtras = '1';
      if (!ul.querySelector('a[href="/products/model-x"]')) {
        var eLink = ul.querySelector('a[href="/products/model-e-for-bondage"]');
        var xItem = makeItem('/products/model-x', 'model X... bigger bodies');
        if (eLink) { eLink.closest('li').insertAdjacentElement('afterend', xItem); }
        else { ref.closest('li').insertAdjacentElement('afterend', xItem); }
      }
      if (!ul.querySelector('a[href="/products/t-shirt"]')) {
        var clothing = ul.querySelector('a[href="/collections/clothing"]');
        var tItem = makeItem('/products/t-shirt', 'A T-Shirt');
        if (clothing) { clothing.closest('li').insertAdjacentElement('afterend', tItem); }
        else { ul.appendChild(tItem); }
      }
    });
  }

  // Footer: the "footer" nav menu still has a "Links to Friends" item pointing at an
  // empty page. Menu items live in Shopify admin, so rewrite it client-side to
  // "Become an affiliate" → the affiliate program page.
  function initFooterFriendsLink() {
    document.querySelectorAll('a[href*="/pages/sca-affiliate-empty-page"]').forEach(function (a) {
      a.setAttribute('href', '/pages/affiliate');
      a.textContent = 'Become an affiliate';
    });
    // Header/menu "Affiliate program" still points at the old (deleted) page handle.
    // Repoint any lingering links to the new /pages/affiliate page.
    document.querySelectorAll('a[href*="/pages/affiliate-and-influencers-info"]').forEach(function (a) {
      a.setAttribute('href', '/pages/affiliate');
    });
  }

  // Videos page: remove the two '"A" LOT OF WEIGHT!' embeds (YouTube id HJiJRRYTn1I).
  // They live in the page body content; strip the iframe + any now-empty wrapper.
  function initRemoveWeightVideos() {
    document.querySelectorAll('iframe[src*="HJiJRRYTn1I"]').forEach(function (f) {
      var wrap = f.parentElement;
      f.remove();
      while (wrap && wrap !== document.body && !wrap.querySelector('iframe, img, video')
             && wrap.textContent.trim() === '' && /^(P|DIV|SPAN|FIGURE)$/.test(wrap.tagName)) {
        var parent = wrap.parentElement; wrap.remove(); wrap = parent;
      }
    });
  }

  // Homepage ALL PRODUCTS: give every card an "Add to cart" button at the bottom.
  // Uses Venue's <product-form notify-on-add> so the cart notification still fires.
  function initCardAddToCart() {
    var sec = document.querySelector('[id*="section_collection_Eh3F4j"]');
    if (!sec) return;
    sec.querySelectorAll('.product-card').forEach(function (card) {
      if (card.classList.contains('ass-modelx-ph') || card.querySelector('.ass-card-addwrap')) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
      if (!m) return;
      var handle = m[1];

      var pf = document.createElement('product-form');
      pf.setAttribute('notify-on-add', '');
      pf.className = 'ass-card-addwrap';
      pf.innerHTML =
        '<form action="/cart/add" method="post" enctype="multipart/form-data" novalidate>' +
          '<input type="hidden" name="form_type" value="product">' +
          '<input type="hidden" name="utf8" value="✓">' +
          '<input type="hidden" name="id" value="">' +
          '<button type="submit" name="add" class="ass-card-add" disabled>Add to cart</button>' +
        '</form>';
      card.appendChild(pf);

      var idInput = pf.querySelector('input[name="id"]');
      var btn = pf.querySelector('.ass-card-add');
      var sw = card.querySelector('product-card-variant-swatch[variant-id]');
      if (sw && sw.getAttribute('variant-id')) {
        idInput.value = sw.getAttribute('variant-id');
        btn.disabled = false;
      } else {
        fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (prod) {
          var v = (prod.variants || []).filter(function (x) { return x.available; })[0] || (prod.variants || [])[0];
          if (!v) return;
          idInput.value = v.id;
          btn.disabled = !v.available;
          if (!v.available) btn.textContent = 'Sold out';
        }).catch(function () {});
      }
    });
  }

  // Mobile header: put "ASlingSwing.com" in the center (between hamburger and the
  // search/cart icons). Hidden on desktop via CSS.
  function initMobileBrand() {
    var header = document.querySelector('.header');
    if (!header || header.querySelector('.ass-mbrand')) return;
    var a = document.createElement('a');
    a.className = 'ass-mbrand';
    a.href = '/';
    a.textContent = 'ASlingSwing.com';
    header.appendChild(a);
  }

  // Photos page: flag the body so CSS can lay the images out as a gallery grid.
  function initPhotosPage() {
    if (/\/pages\/photos/i.test(location.pathname)) document.body.classList.add('ass-photos');
  }

  // Flag PDPs whose Color option should render as solid color blocks (CSS keys on
  // body.ass-colorblocks + the swatch value). Powder coating also keeps ass-powder.
  function initColorBlockPages() {
    var path = location.pathname;
    if (/\/products\/powder-coating/i.test(path)) document.body.classList.add('ass-powder');
    if (/\/products\/(powder-coating|model-s|model-e-for-bondage|model-x)(\/|$|\?)/i.test(path)) {
      document.body.classList.add('ass-colorblocks');
    }
  }

  // Affiliate page: the page body only has a bare submit button that navigates the
  // whole browser off to UpPromote. Embed the registration form inline (the register
  // page allows framing) with a "Coming Soon" notice as the text on top of the form.
  function initAffiliateForm() {
    if (!/\/pages\/affiliate-and-influencers-info/i.test(location.pathname)) return;
    var form = document.querySelector('form[action*="uppromote"]');
    if (!form || form.dataset.assEmbedded) return;
    var url = (form.getAttribute('action') || 'https://af.uppromote.com/ASlingSwing/register').replace(/\/+$/, '');
    var wrap = document.createElement('div');
    wrap.className = 'ass-affiliate-embed';
    wrap.dataset.assEmbedded = '1';
    wrap.innerHTML =
      '<div class="ass-affiliate-soon">' +
        '<div class="ass-soon-badge">Coming Soon</div>' +
        '<p class="ass-soon-text">Our affiliate program is launching soon — sign up below to be first in line!</p>' +
      '</div>' +
      '<iframe class="ass-affiliate-iframe" src="' + url + '" title="Affiliate registration form" loading="lazy"></iframe>' +
      '<p class="ass-affiliate-fallback">Form not loading? <a href="' + url + '" target="_blank" rel="noopener">Open the affiliate sign-up in a new tab</a>.</p>';
    form.replaceWith(wrap);
  }

  // Contact page: add a tap-to-call button at the top of the content.
  function initContactCallButton() {
    if (!/\/pages\/contact/i.test(location.pathname)) return;
    var content = document.querySelector('.page__content, .rte');
    if (!content || content.querySelector('.ass-call-btn')) return;
    var wrap = document.createElement('div');
    wrap.className = 'ass-call-wrap';
    var a = document.createElement('a');
    a.className = 'ass-call-btn';
    a.href = 'tel:+14074151963';
    a.innerHTML = '<span class="ass-call-btn__ico">☎</span> Call (407) 415-1963';
    wrap.appendChild(a);
    content.insertBefore(wrap, content.firstChild);
  }

  // Video gallery: the main-stage custom poster/thumbnail is requested cropped to the
  // player's 16:9 (?crop=center&height=…) and shown object-fit:cover. For portrait custom
  // thumbnails that chops the image. Strip the crop from the URL so the full image loads,
  // and CSS switches the poster to object-fit:contain so nothing is cut off.
  function initVideoPosterUncrop() {
    function strip(u) {
      return u
        .replace(/&?crop=[^&\s]*/gi, '')
        .replace(/&?height=\d+/gi, '')
        .replace(/\?&/g, '?');
    }
    document.querySelectorAll('.home-video__stage .video-poster img').forEach(function (img) {
      if (img.dataset.assUncrop) return;
      img.dataset.assUncrop = '1';
      ['src', 'srcset'].forEach(function (attr) {
        var v = img.getAttribute(attr);
        if (v && v.indexOf('crop=') > -1) img.setAttribute(attr, strip(v));
      });
    });
  }

  // Site-wide content protection: block right-click, copy/cut, selection + image drag.
  // Form fields stay usable (so people can still type/paste into search, contact, qty).
  function initSiteProtect() {
    if (window.__assProtected) return;
    window.__assProtected = true;
    var inField = function (t) {
      return t && t.closest && t.closest('input, textarea, select, [contenteditable="true"]');
    };
    document.addEventListener('contextmenu', function (e) { if (!inField(e.target)) e.preventDefault(); });
    document.addEventListener('dragstart', function (e) { e.preventDefault(); });
    document.addEventListener('copy', function (e) { if (!inField(e.target)) e.preventDefault(); });
    document.addEventListener('cut', function (e) { if (!inField(e.target)) e.preventDefault(); });
    document.addEventListener('selectstart', function (e) { if (!inField(e.target)) e.preventDefault(); });
  }

  function initAll(root) { initVariantButtons(root); initManualProtect(); initTopCarousel(root); initFeaturedButtons(root); initFooterSocialUnderLogo(); initFooterFriendsLink(); initProductsDropdownExtras(); initRemoveWeightVideos(); initCardAddToCart(); initMobileBrand(); initPhotosPage(); initColorBlockPages(); initAffiliateForm(); initContactCallButton(); initVideoPosterUncrop(); initSiteProtect(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
